import { useMemo } from 'react';

import { getPasswordRules } from '@/modules/auth/utils/validatePassword';

export const validatePasswordRules = (password: string) => {
  const passwordRules = getPasswordRules(password);
  const isFailing = passwordRules.some((rule) => rule.isFailing);
  return {
    passwordRules,
    isFailing,
  };
};

export const usePasswordRules = (password: string) => {
  return useMemo(() => {
    return validatePasswordRules(password);
  }, [password]);
};
